import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '../../../../components/CiscoUi';
import { PrimaryButton } from '../../../../components/Buttons/PrimaryButton';
import { useEditNetworkForm } from '../../hooks/use-edit-network-form';
import {
  NetworkDescriptionInput,
  NetworkNameInput,
  NetworkRoutedCheckbox,
  NetworkSubnetSelect,
} from '../NetworkForm';
import { ControlledCheckbox } from '../../../../components';
import styles from './EditNetworkForm.module.css';
import { EditNetworkFormProps } from '.';

export function EditNetworkForm({
  availableRouted,
  availableUnrouted,
  editing,
  networkNames,
  networkToEdit,
  nodeData,
  updateNode,
  updateNetwork,
  isLastRouted,
  customOnSubmit,
}: EditNetworkFormProps): ReactElement {
  const { t } = useTranslation();
  const {
    alertMessage,
    control,
    errors,
    handleSubmit,
    isDirty,
    isNetworkCheckboxDisabled,
    isRouted,
    isValid,
    onRoutedChange,
    onSubmit,
    subnetOptions,
  } = useEditNetworkForm({
    availableRouted,
    availableUnrouted,
    customOnSubmit,
    isLastRouted,
    networkNames,
    networkToEdit,
    nodeData,
    updateNetwork,
    updateNode,
  });

  return (
    <form className={styles.root}>
      <NetworkNameInput control={control} errorMesage={errors?.name?.message} />
      <NetworkDescriptionInput
        control={control}
        errorMesage={errors?.description?.message}
      />
      <NetworkRoutedCheckbox
        isChecked={isRouted}
        isDisabled={isNetworkCheckboxDisabled}
        onChange={onRoutedChange}
        data-testid="network-form-routed-checkbox"
      />
      {alertMessage && <Alert colour="info">{alertMessage}</Alert>}
      <NetworkSubnetSelect
        control={control}
        errorMesage={errors?.subnet?.message}
        options={subnetOptions}
      />
      <ControlledCheckbox
        className={styles.checkbox}
        control={control}
        id="hiddenFromSession"
        label={t('networks.form.edit.hiddenFromSession')}
        testId="edit-network-hiddenFromSession-checkbox"
      />
      <div className={styles.submit}>
        <PrimaryButton
          colour="success"
          disabled={!isDirty || !isValid}
          className="dbl-margin-top"
          onClick={handleSubmit(onSubmit)}
          loading={editing}
          testId="network-form-submit-btn"
        >
          {t('buttons.update')}
        </PrimaryButton>
      </div>
    </form>
  );
}
